import React from "react";

function SparkImportHistoryReportBuilder({
  template,
  reportResults,
  formatFieldName
}) {
  const selectedColumns = Array.isArray(reportResults?.selectedColumns)
    ? reportResults.selectedColumns
    : Array.isArray(template?.definition?.defaultColumns)
      ? template.definition.defaultColumns
      : [
          "created_at",
          "event_type",
          "external_unique_id",
          "external_contact_id",
          "processing_status",
          "processed_at",
          "error_message"
        ];

  const rows = Array.isArray(reportResults?.rows) ? reportResults.rows : [];

  const getStatusClass = (status) => {
    const normalized = String(status || "").toLowerCase();

    if (normalized === "processed") return "sales-status-active";
    if (normalized === "failed") return "sales-status-cancelled";
    if (normalized === "received") return "sales-status-pending";

    return "sales-status-default";
  };

  return (
    <div className="sales-table-card">
      <div className="sales-table-header">
        <div>
          <h2>Spark Import History</h2>
          <p>
            {reportResults
              ? `${rows.length} Spark import${rows.length === 1 ? "" : "s"} found.`
              : "Click Run Report to view recent Spark Contact Sync imports."}
          </p>
        </div>
      </div>

      <div
        style={{
          margin: "0 16px 16px",
          padding: "14px 16px",
          borderRadius: "14px",
          background: "#f8fafc",
          border: "1px solid #dbe4f0",
          color: "#475569",
          lineHeight: 1.6,
          fontSize: "14px"
        }}
      >
        This report shows Spark webhook imports received for this subscriber account,
        including event type, Spark contact identifiers, processing status, and errors.
      </div>

      <div className="sales-table-wrap">
        <table className="sales-table">
          <thead>
            <tr>
              {selectedColumns.map((column) => (
                <th key={column}>
                  {formatFieldName ? formatFieldName(column) : column}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {!reportResults ? (
              <tr>
                <td colSpan={selectedColumns.length} className="sales-empty-cell">
                  Run the report to load Spark import history.
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan={selectedColumns.length} className="sales-empty-cell">
                  No Spark imports found.
                </td>
              </tr>
            ) : (
              rows.map((row, rowIndex) => (
                <tr key={`${row.external_unique_id || "spark"}-${rowIndex}`}>
                  {selectedColumns.map((column) => {
                    const value = row[column] ?? "";

                    if (column === "processing_status") {
                      return (
                        <td key={column}>
                          <span className={`sales-status-pill ${getStatusClass(value)}`}>
                            {value || "-"}
                          </span>
                        </td>
                      );
                    }

                    if (column === "error_message") {
                      return (
                        <td key={column}>
                          {value ? (
                            <span style={{ color: "#b91c1c" }}>{value}</span>
                          ) : (
                            "-"
                          )}
                        </td>
                      );
                    }

                    return <td key={column}>{value || "-"}</td>;
                  })}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SparkImportHistoryReportBuilder;